import { enableProdMode, importProvidersFrom } from '@angular/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ApiModule } from './app/apiAndObjects/api.module';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { DialogModule } from './app/components/dialog/dialog.module';
import { ComponentsModule } from './app/components/components.module';
import { ServicesModule } from './app/services/services.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      AppRoutingModule,
      ApiModule,
      ComponentsModule,
      ServicesModule,
      DialogModule.forRoot(),
      MatMomentDateModule,
    ),
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    provideAnimations(),
  ],
}).catch((err) => console.error(err));
